import { render, staticRenderFns } from "./ListExternalCate.vue?vue&type=template&id=f7dd1484&scoped=true"
import script from "./ListExternalCate.vue?vue&type=script&lang=js"
export * from "./ListExternalCate.vue?vue&type=script&lang=js"
import style0 from "./ListExternalCate.vue?vue&type=style&index=0&id=f7dd1484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7dd1484",
  null
  
)

export default component.exports